import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss'],
})
export class ChipComponent {
  @Input() label: string = '';
  @Input() iconName: string = '';
  @Input() svgIconName: string = '';
  @Input() isSelected: boolean = false;
  @Input() isDisabled: boolean = false;

  @Output() readonly selectedChange = new EventEmitter<boolean>();

  toggle(): void {
    if (this.isDisabled) {
      return;
    }

    this.selectedChange.emit(!this.isSelected);
  }
}
